<template>
  <div
    class="card-body border rounded mt-4"
    :class="theme == 'light' ? 'bg-white' : 'border-info'"
  >
    <h5 class="card-title mb-2">
      {{ $t("dashboards.top-malware") }} <br /><span class="text-info"
        >25 {{ $t("dashboards.day") }}</span
      >
    </h5>
    <table class="table">
      <thead>
        <tr>
          <td>name</td>
          <td>total</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cs in classification" :key="cs.id">
          <td>{{ cs.detect_name }}</td>
          <td>{{ cs.total }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ElasticService from "@/helpers/elastic.service";
import moment from "moment";
import _ from "lodash";
/**
 * Email-sent component
 */
export default {
  data() {
    return {
      theme: localStorage.getItem("theme"),
      malwareClass: [],
      classification: [],
    };
  },
  methods: {
    getAhn() {
      console.log("get ahn");
      ElasticService.getAhnLab()
        .then((response) => {
          let data_ahn = response.data.hits.hits;
          // console.log(data_ahn);
          const grouped = _.groupBy(data_ahn, (rep) => rep._source.detect_name);

          console.log("group", grouped);

          _.map(_.values(grouped), (arr) => {
            console.log("arr", arr.length);

            const val = arr[0];

            const data = {
              id: val._source.id,
              detect_time: val._source.detect_time,
              detect_name: val._source.detect_name,
              total: arr.length,
            };

            this.malwareClass.push(data);
          });

          let sort = _.orderBy(this.malwareClass, ["total"], ["desc"]);

          this.classification = sort;
          console.log("sort", sort);
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    cekClassification(value) {
      // console.log('val', value);
      console.log("start");
      let index = this.malwareClass.findIndex(
        (element) => element["detect_name"] == value
      );
      let cut = this.malwareClass.splice(index, 1);
      console.log("cut", cut);
      cut.forEach((val) => {
        const new_data = {
          id: val.id,
          detect_time: val.detect_time,
          detect_name: val.detect_name,
          total: val.total,
        };
        console.log("new", new_data);
        this.classification.push(new_data);
      });
    },
  },
  mounted() {
    this.getAhn();
  },
};
</script>